import { useAppSelector } from '../../../state/hooks'
import {
  selectAttemptPayment,
  selectTerminalStatusLoadingState,
  selectTerminalStatusWarningType,
} from '../../../state/slices/terminalStatus/terminalStatusSlice'

export const useTerminalStatusFromRedux = () => {
  const isLoading = useAppSelector(selectTerminalStatusLoadingState)
  const isAttemptingPayment = useAppSelector(selectAttemptPayment)
  const warningType = useAppSelector(selectTerminalStatusWarningType)

  return {
    isLoading,
    isAttemptingPayment,
    warningType,
  }
}
